import { GDFWmoCatRecord } from '../../../gdf/type';
import { mapTurbulenceSeverityToSeverityColor } from '../../../worker/store/helpers';

export default function WmoCatTooltip({ record }: { record: GDFWmoCatRecord }) {
    const color = mapTurbulenceSeverityToSeverityColor(record.severity);
    let severityString = '';
    switch (color) {
        case 0:
            severityString = 'Light';
            break;
        case 1:
            severityString = 'Moderate';
            break;
        case 2:
            severityString = 'Severe';
            break;
        case 3:
            severityString = 'Extreme';
            break;
    }
    return (
        <div style={{ whiteSpace: 'pre' }}>
            <div>Turbulence</div>
            <div>Severity: {severityString}</div>
            {record.base && <div>Base: {record.base}</div>}
            {record.top && <div>Top: {record.top}</div>}
        </div>
    );
}
